module.exports = __webpack_public_path__ + "img/tarjeta_ofertas_seguro_salud_1_mes_gratis.630506ec.jpg";